/*
 * Quem curtiu / quem reagiu: o popover que abre ao
 * clicar na contagem da barra do post — cartão branco com sombra, uma seta
 * apontando para a contagem, e a lista (avatar de 32px, nome e, à direita, o
 * coração ou o emoji da reação de cada um). Rola depois de ~8 pessoas.
 *
 * Serve às curtidas (flarum/likes) e às reações (fof/reactions): quem abre
 * passa o carregador da lista. Há um popover só para a página, montado num
 * <div> do body — dentro do post ele seria cortado e ficaria preso ao
 * SubtreeRetainer.
 */
import app from 'flarum/forum/app';
import Avatar from 'flarum/common/components/Avatar';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import username from 'flarum/common/helpers/username';
let state = null;
let root = null;

/** Distância da seta até a contagem e das bordas da janela. */
const GAP = 10;
const EDGE = 8;
function onDocumentEvent(event) {
  if (!state) return;
  if (event instanceof KeyboardEvent) {
    if (event.key === 'Escape') closeWhoReacted();
    return;
  }
  const target = event.target;
  if (root?.contains(target) || state.anchor.contains(target)) return;
  closeWhoReacted();
}
function ensureRoot() {
  if (root) return;
  root = document.createElement('div');
  root.className = 'CanelaReactorsRoot';
  document.body.appendChild(root);
  m.mount(root, {
    view: () => state ? m(ReactorsPopover, {
      anchor: state.anchor,
      entries: state.entries
    }) : null
  });
  document.addEventListener('mousedown', onDocumentEvent, true);
  document.addEventListener('keydown', onDocumentEvent, true);
  window.addEventListener('popstate', () => closeWhoReacted());
}
export function closeWhoReacted() {
  if (!state) return;
  state = null;
  m.redraw();
}

/** Abre (ou fecha, num segundo clique na mesma contagem) a lista de quem reagiu. */
export function openWhoReacted(anchor, load) {
  ensureRoot();
  if (state && state.anchor === anchor) {
    closeWhoReacted();
    return;
  }
  const current = {
    anchor,
    entries: null
  };
  state = current;
  m.redraw();
  load().catch(() => []).then(entries => {
    if (state !== current) return;

    // Ninguém visível (sem permissão, ou a lista falhou): um cartão vazio
    // não diz nada — o popover simplesmente fecha.
    if (!entries.length) {
      closeWhoReacted();
      return;
    }
    current.entries = entries;
    m.redraw();
  });
}

/** O coração vermelho das curtidas (como o emoji ❤️). */
export function heartIcon() {
  return m("i", {
    "aria-hidden": "true",
    className: "icon fas fa-heart CanelaReactors-heart"
  });
}
class ReactorsPopover {
  view(vnode) {
    const {
      entries
    } = vnode.attrs;
    return m("div", {
      className: "CanelaReactors",
      role: "dialog",
      "aria-label": app.translator.trans('ramon-canela.forum.topic.post.who_liked', {}, true)
    }, m("span", {
      className: "CanelaReactors-arrow"
    }), entries === null ? m(LoadingIndicator, {
      size: "small",
      display: "block"
    }) : m("ul", {
      className: "CanelaReactors-list"
    }, entries.map(entry => m("li", null, m(Link, {
      className: "CanelaReactors-user",
      href: app.route.user(entry.user),
      onclick: () => closeWhoReacted()
    }, m(Avatar, {
      user: entry.user
    }), m("span", {
      className: "CanelaReactors-name"
    }, username(entry.user)), m("span", {
      className: "CanelaReactors-icon"
    }, entry.icon))))));
  }
  oncreate(vnode) {
    this.place(vnode);
  }
  onupdate(vnode) {
    this.place(vnode);
  }

  /** Logo abaixo da contagem, centrado nela, sem sair da janela. */
  place(vnode) {
    const el = vnode.dom;
    const rect = vnode.attrs.anchor.getBoundingClientRect();
    const width = el.offsetWidth;
    const center = rect.left + rect.width / 2;
    const left = Math.max(EDGE, Math.min(window.innerWidth - width - EDGE, center - width / 2));
    el.style.top = `${rect.bottom + window.scrollY + GAP}px`;
    el.style.left = `${left + window.scrollX}px`;
    el.style.setProperty('--cn-arrow-left', `${center - left}px`);
  }
}
flarum.reg.add('ramon-canela', 'forum/topic/components/WhoReactedPopover', { closeWhoReacted: closeWhoReacted,openWhoReacted: openWhoReacted,heartIcon: heartIcon, });